import { SchemaFormFields } from '@mews-commander/form';
import { OptimusProvider } from '@mews-commander/ui';
import { filterSchema, useFormDefinition } from './filterSchema';

export const FilterFields = () => {
    const formDefinition = useFormDefinition();

    return (
        <OptimusProvider density="spacious">
            <SchemaFormFields schema={filterSchema} formDefinition={formDefinition} />
        </OptimusProvider>
    );
};
